export default function oneOf (choices, ...args) {
  let checker = (obj, key, cname, location, fullName) => {
    let value = obj[key];
    if (!choices.includes(value)) {
      return new TypeError(`Value at ${fullName} is must be one of: ${choices.join(' or ')} (got ${value})`);
    }
  };
  checker.checkerName = 'oneOf';
  if (args.length > 0) {
    throw new Error(`Extraneous arguments to ${checker.checkerName}`);
  }
  if (!Array.isArray(choices)) {
    throw new Error(`Invalid argument type to ${checker.checkerName}: ${choices}`);
  }
  if (choices.length < 2) {
    throw new Error(`A ${checker.checkerName} with less than 2 choices is non-sensical.`);
  }
  return checker;
}




// WEBPACK FOOTER //
// ./lib/rlink-shapes/oneOf.js